import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FeaturesListing from "@components/FeaturesListing/FeaturesListing";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import Meta from "@components/Meta/Meta";
import { remAccents } from "@helpers/utils.js";

const root = process.env.REACT_APP_CMS_STATIC;

function TarjetasListado(props) {
  //const { match: { params } } = props;
  const [matches, setMatches] = useState([]);
  const [cardsData, setCardsData] = useState([]);

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);

  const { tarjetasCredito } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  const defRoute = rutas?.filter((route) => route?.name === "Tarjetas Listado");

  const prevRoute = defRoute.map((route) => {
    return {
      url: route.url,
      text: route.title,
    };
  });

  useEffect(() => {
    let promise = new Promise((resolve, reject) => {
      let normalizeCards =
        tarjetasCredito &&
        tarjetasCredito?.map((card) => ({
          ...card,
          nombre: remAccents((card?.titulo).replace(/ /gi, "-").toLowerCase()),
          rutaPrevia: prevRoute,
        }));
      resolve(normalizeCards);
    });

    promise.then((resultado) => setMatches(resultado));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tarjetasCredito]);

  useEffect(() => {
    const curSection = rutas && rutas.filter((uri) => uri.name === "Tarjetas");
    const rootUri = curSection && curSection[0]?.url;

    let items =
      matches &&
      matches.map((card) => {
        const botones = card?.botones?.contentItems;
        const masInfoBtn = botones.filter(
          (btn) =>
            btn.ruta.text.toLowerCase() === "Más Información".toLowerCase() ||
            btn.ruta.text.toLowerCase() === "Solicite su tarjeta".toLowerCase()
        );
        return {
          title: card?.titulo,
          image: root + card?.imagen?.urls[0],
          url: rootUri.replace("/:id", "/" + card.nombre),
          description: card?.descripcion?.html,
          buttons: masInfoBtn.sort((a, b) => {
            const nameA = a.ruta.text.toUpperCase(); // ignore upper and lowercase
            const nameB = b.ruta.text.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            // names must be equal
            return 0;
          }),
        };
      });

    setCardsData(items);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches]);

  return (
    <div className="pt-5">
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.title} />
      <h1 className="slogan">{defRoute[0].h1}</h1>
      <FeaturesListing features={cardsData} />
    </div>
  );
}

export default TarjetasListado;
